<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import type { CourseTrainer } from "../../courseTrainers.js";
	import translations from "./CourseTrainerBadge.translations.json" with { type: "json" };

	const { trainer }: { trainer: CourseTrainer } = $props();
	const translate = getTranslate(translations);
	const { tenant } = getGlobalTemplateProps();
</script>

<div class="flex items-center gap-4">
	<img
		src={trainer.avatar.src}
		alt={trainer.name}
		width={trainer.avatar.width}
		height={trainer.avatar.height}
		loading="lazy"
		class="size-16 shrink-0 rounded-full object-cover bg-fcrlightgray-400"
	/>
	<div class="flex min-w-0 flex-col">
		<span class="text-2xs uppercase font-bold tracking-[.1em] text-fcrorange">
			<Formatted text={translate("label")} />
		</span>
		<span class="font-antipol font-medium text-lg/tight text-fcrdarkgray mt-1">
			<Formatted text={trainer.name} />
		</span>
		<span class="text-sm/normal text-fcrgray mt-0.5">
			<Formatted text={trainer.highlight[tenant.locale]} />
		</span>
	</div>
</div>
